import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudCheckboxModule,
	FreudInputNumberModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AddressCorporativePriceComponent } from './address-coorporative-price.component';

@NgModule({
	declarations: [AddressCorporativePriceComponent],
	imports: [
		CommonModule,
		FreudCardModule,
		FreudButtonModule,
		FreudInputNumberModule,
		ReactiveFormsModule,
		TranslateModule,
		FreudCheckboxModule,
	],
	exports: [AddressCorporativePriceComponent],
})
export class AddressCorporativePriceModule {}
